import { useRecoilValue } from "recoil";
import TimerControllerHeader from "./components/header";
import TimerControllerHeaderInfo from "./components/header-info";
import TimerControllerSitIn from "./components/sit-in";
import { ControllerParticipation } from "./components/sit-in/components/participation";
import ControllerQrReEntryPopup from "./components/sit-in/components/qr-re-entry";
import ControllerReEntryPopup from "./components/sit-in/components/re-entry";
import { useParticipantContext } from "./components/sit-in/hooks/participant-context";
import TimerControllerSkinSelector from "./components/skin-selector";
import TimerControllerTabs from "./components/tabs";
import TimerControllerTournamentInfo from "./components/tournament-info";
import { useControllerContext } from "./hooks/controller-context";
import { ControllerTab } from "./hooks/use-controller-tab";
import {
  ControllerWrapper,
  TimerControllerContentWrapper,
  TimerControllerHeaderWrapper,
} from "./style";
import { WideState } from "../../recoil/wide";
import MobileTimerController from "./components/mobile";
import { StructuresResponse } from "../tournament/hook/useEditTournament";
import { Overlay } from "../../styles/popup";
import TimerControllerStatus from "./components/status";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { pubState } from "../../recoil/pub.atom";
import { useEffect } from "react";
import { PubOwnerRole, PubOwnerDomain } from "../../api/cafe";

export interface TimerInfoState {
  elapsedTimeInCurrentLevel: string | null;
  elapsedTimeMs: number | null;
  elapsedTime: string | null;
  currentLevel: StructuresResponse | null;
  remainingTimeInCurrentLevel: string;
  timeUntilNextBreak: string | null;
  elapsedTimeInCurrentLevelMs: number | null;
  remainingTimeInCurrentLevelMs: number | null;
}

const TimerController = () => {
  const { isControllerTab, isPopup, data } = useControllerContext();
  const { isBuyInPopup, isReEntryPopup, isQrReEntryPopup } =
    useParticipantContext();
  const isWide = useRecoilValue(WideState);
  const pub = useRecoilValue(pubState);
  const navigate = useNavigate();

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.TOURNAMENT)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  if (!isWide) {
    return (
      <>
        <Helmet>
          <title>{data?.title}</title>
        </Helmet>
        <MobileTimerController />
      </>
    );
  }
  return (
    <>
      <Helmet>
        <title>{data?.title}</title>
      </Helmet>
      <ControllerWrapper>
        {/* 참가 로직 팝업 */}
        {isBuyInPopup && <ControllerParticipation />}
        {/* 애드온 / 리바인 팝업 */}
        {isReEntryPopup && <ControllerReEntryPopup />}
        {/* QR 참가방식 선택 팝업 */}
        {isQrReEntryPopup && <ControllerQrReEntryPopup />}
        <TimerControllerHeaderWrapper>
          <TimerControllerHeader /> {/* 컨트롤러 해더 */}
          <TimerControllerHeaderInfo /> {/* 컨트롤러 해더 정보 */}
        </TimerControllerHeaderWrapper>
        <TimerControllerContentWrapper>
          <TimerControllerTabs /> {/* 컨트롤러 탭 */}
          {isControllerTab(ControllerTab.TOURNAMENT) && (
            <TimerControllerTournamentInfo /> // 토너먼트 정보
          )}
          {isControllerTab(ControllerTab.TIMER) && (
            <TimerControllerSkinSelector /> // 타이머 관리
          )}
          {isControllerTab(ControllerTab.SIT_IN) && (
            <TimerControllerSitIn /> // 싯인 관리
          )}
          {isControllerTab(ControllerTab.STATUS) && (
            <TimerControllerStatus /> // 진행현황
          )}
        </TimerControllerContentWrapper>
        {isPopup && <Overlay />}
      </ControllerWrapper>
    </>
  );
};

export default TimerController;
